import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { toastService } from "../../../utils/toastify";
import userImg from "../../../assets/images/admin.png";
import { getLiveRating } from "../../../features/slices/liveStream";
const LiveStreamReview = () => {
  const [ratingByAdmin, setRatingByAdmin] = useState("");
  const dispatch = useDispatch();
  const { state } = useLocation();
  useEffect(() => {
    if (state) dispatch(getLiveRating({ id: state }));
  }, [state]);
  const { ratingData, loading } = useSelector((state) => state?.liveStream);

  const [averageRating, setaverageRating] = useState(0);
  const [detailedRating, setDetailedRating] = useState([{}]);
  useEffect(() => {
    if (state) {
      const totalUser = ratingData?.result?.[0]?.ratingData;
      const sumRating = ratingData?.result?.[0]?.ratingData?.reduce(
        (acc, rating) => {
          return rating?.startCount ? acc + rating?.startCount : acc;
        },
        0
      );
      const obj = {};
      const average = sumRating / totalUser?.length || 0;

      setaverageRating(Math.round(average));
      ratingData?.result?.[0]?.ratingData?.forEach((rating, i, data) => {
        if (rating?.startCount in obj) {
          obj[rating?.startCount]++;
        } else {
          obj[rating?.startCount] = 1;
        }
        const star = [
          ...new Set(data.map((result) => result?.startCount || 0)),
        ];

        const fullDetailRating = star.map((str) => ({
          precentage: (obj[str] / data?.length) * 100 || 0,
          star: str,
        }));
        setDetailedRating(fullDetailRating);
      });
    }
  }, [state, ratingData]);
  console.log({ averageRating, detailedRating });

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Rating and Reviews</h4>
          </div>
          <div className="LiveStreamAreaArea w-100">
            <div className="AverageReviewBox">
              <h4>Average Review</h4>
              <aside>
                <h5>{averageRating}</h5>

                <div className="Ratings">
                  {Array.from({ length: 5 }, (_, index) => {
                    return (
                      <span key={index}>
                        <i
                          className={
                            index < averageRating
                              ? "fa-solid fa-star checked"
                              : "fa-regular fa-star"
                          }
                        />
                      </span>
                    );
                  })}
                </div>

                <p>Rating</p>
              </aside>
            </div>
            <div className="ProgressBarArea Width">
              <h4>Detailed Rating</h4>

              <ul>
                {detailedRating?.map((detailRat, i) => {
                  return (
                    <li key={i}>
                      <label>{detailRat?.precentage?.toFixed(2) || 0}%</label>
                      <div className="Ratings d-flex">
                        {Array.from({ length: 5 }, (_, index) => (
                          <span key={index}>
                            <i
                              className={
                                index < detailRat?.star
                                  ? "fa-solid fa-star checked"
                                  : "fa-regular fa-star"
                              }
                            />
                          </span>
                        ))}
                      </div>
                      <div className="ProgressBar">
                        <span
                          className="Progress"
                          style={{
                            width: `${detailRat?.precentage?.toFixed(2) || 0}%`,
                          }}
                        />
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div style={{ clear: "both" }} />
          <div className="RatingComment">
            {ratingData?.result?.[0]?.ratingData?.map((data, i) => {
              return (
                <article key={i}>
                  <aside>
                    <figure>
                      <img src={data?.user?.profilePic || userImg} />
                    </figure>
                    <figcaption>
                      <h6>{data?.user?.fullName}</h6>
                      <div className="Ratings">
                        {Array.from({ length: 5 }, (_, index) => (
                          <span key={index}>
                            <i
                              className={
                                index < data?.startCount
                                  ? "fa-solid fa-star"
                                  : "fa-regular fa-star"
                              }
                            />
                          </span>
                        ))}
                      </div>
                    </figcaption>
                  </aside>
                  <p>{data?.comment}</p>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveStreamReview;
